export default __webpack_public_path__ + "assets/images/button-smiles.ee945f9575992cef926889b828847f48.svg";